import React, { useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import { loginRequest } from "../authConfig"; // ✅ make sure this is defined

const LoginPage = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ✅ Debug: log account info
  useEffect(() => {
    console.log("🧾 MSAL Accounts:", accounts);
    if (accounts && accounts.length > 0) {
      const redirectPath = location.state?.from?.pathname || "/home";
      console.log("✅ Redirecting to:", redirectPath);
      navigate(redirectPath, { replace: true });
    }
  }, [accounts, navigate, location]);

  const handleSignIn = () => {
    console.log("🚪 Initiating login redirect...");
    instance.loginRedirect(loginRequest);
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid item xs={12} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <AccountCircle sx={{ fontSize: 64, color: "#1976d2", mb: 2 }} />
          <Typography component="h1" variant="h5" sx={{ mb: 4 }}>
            Sign in with Microsoft
          </Typography>
          <Button
            fullWidth
            variant="contained"
            sx={{ bgcolor: "#1976d2" }}
            onClick={handleSignIn}
          >
            Login with Microsoft
          </Button>
        </Box>
      </Grid>
      {!isMobile && (
        <Grid
          item
          md={7}
          sx={{
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h3" sx={{ color: "#333", fontWeight: 500 }}>
            Welcome.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default LoginPage;
